module.exports = __webpack_public_path__ + "static/img/a1en.730d167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a1en.png
// module id = /PNL
// module chunks = 0